import React from "react";
import ContainerCountStep from "./steps/ContainerCountStep";
import ReadBarcodeStep from "./steps/ReadBarcodeStep";
import DetectObjectStep from "./steps/DetectObjectStep";
import ManualCaptureMultipleStep from "./steps/ManualCaptureMultipleStep";
import QuestionStep from "./steps/QuestionStep";
import IterateStep from "./steps/IterateStep";
import { CameraStreamProps } from "./types/cameraStreamProps";

interface StepRendererProps {
  step: any;
  onStepComplete: (data?: any) => void;
  cameraStreamProps: CameraStreamProps;
  /** Ends the open-ended container loop (only surfaced on the barcode step). */
  onFinish?: () => void;
}

const EMPTY_QUESTION_IDS: string[] = [];
const StepRenderer: React.FC<StepRendererProps> = ({
  step,
  onStepComplete,
  cameraStreamProps,
  onFinish,
}) => {
  // Check if this is an iterate step
  if (step.iterate) {
    return (
      <IterateStep
        iterateSteps={step.iterate}
        cameraStreamProps={cameraStreamProps}
        onFinish={onFinish}
      />
    );
  }

  // Handle regular steps based on type
  if (step.type === "get_drum_count") {
    return (
      <ContainerCountStep
        humanText={step.human_text}
        onComplete={onStepComplete}
      />
    );
  }

  if (step.type === "read_barcode") {
    return (
      <ReadBarcodeStep
        humanText={step.human_text}
        onComplete={onStepComplete}
        onFinish={onFinish}
      />
    );
  }

  if (step.type === "detect_object") {
    const questionIds = step.backend?.question_ids ?? EMPTY_QUESTION_IDS;
    return (
      <DetectObjectStep
        humanText={step.human_text}
        target={step.target}
        activeQuestionIds={questionIds}
        onComplete={onStepComplete}
        cameraStreamProps={cameraStreamProps}
      />
    );
  }

  if (step.type === "manual_capture_multiple") {
    const questionIds = step.backend?.question_ids ?? EMPTY_QUESTION_IDS;
    return (
      <ManualCaptureMultipleStep
        humanText={step.human_text}
        activeQuestionIds={questionIds}
        onComplete={onStepComplete}
      />
    );
  }

  if (step.question_id) {
    return (
      <QuestionStep
        questionId={step.question_id}
        onComplete={onStepComplete}
      />
    );
  }

  // Fallback for unknown step types
  return (
    <div>
      <p>Unknown step type</p>
      <pre>{JSON.stringify(step, null, 2)}</pre>
    </div>
  );
};

export default StepRenderer;
